// Copyright (c) Docugami, Inc. All rights reserved.

import { NotificationType } from "networking/NotificationsApi";

export const limitedNotificationTypes = [NotificationType.WorkPathCta, NotificationType.WorkPathStatus];